import { getRole, getToken, getUser } from "../commons";
import { getAPICall, postAPICall } from "./axiosCommons";
import Moment from "moment";

// GET NGROK
export const searchAttendance = async (date_from, date_to, agent) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "timesheets/search",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(date_from).format("YYYY-MM-DD"),
        date_to: Moment(date_to).format("YYYY-MM-DD"),
        agent: agent,
        user_role: getRole(),
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const getUserDetail = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "users/get",
      {
        requester: getUser(),
        token: getToken(),
        user_id: id,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const addUser = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/add",
      {
        requester: getUser(),
        token: getToken(),
        role: data.role,
        first_name: data.first_name,
        last_name: data.last_name,
        username: data.username,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateUser = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/update",
      {
        requester: getUser(),
        token: getToken(),
        user_id: data.id,
        role: data.role,
        first_name: data.first_name,
        last_name: data.last_name,
        username: data.username,
      }
    );

    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "users/delete",
      {
        requester: getUser(),
        token: getToken(),
        user_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const exportAttendance = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    
    // Check if dateFrom is a dayjs object and convert properly
    let date_from = '';
    if (data.dateFrom) {
      console.log('Processing dateFrom...');
      if (typeof data.dateFrom.format === 'function') {
        // It's a dayjs object
        date_from = data.dateFrom.format("YYYY-MM-DD");
        console.log('dateFrom formatted with dayjs:', date_from);
      } else {
        // Try with Moment.js
        date_from = Moment(data.dateFrom).format("YYYY-MM-DD");
        console.log('dateFrom formatted with Moment:', date_from);
      }
    }
    
    // Check if dateTo is a dayjs object and convert properly
    let date_to = '';
    if (data.dateTo) {
      console.log('Processing dateTo...');
      if (typeof data.dateTo.format === 'function') {
        // It's a dayjs object
        date_to = data.dateTo.format("YYYY-MM-DD");
        console.log('dateTo formatted with dayjs:', date_to);
      } else {
        // Try with Moment.js
        date_to = Moment(data.dateTo).format("YYYY-MM-DD");
        console.log('dateTo formatted with Moment:', date_to);
      }
    }
    
    const agent = data.agent || '';
    
    console.log('Final formatted dates - date_from:', date_from, 'date_to:', date_to);

    const url = 
      process.env.REACT_APP_LINK +
      `timesheets/export_to_excel?requester=${requester}&token=${token}&date_from=${date_from}&date_to=${date_to}&agent=${agent}`;

    const response = await getAPICall(url, {}, { responseType: 'blob' });
    
    // Create blob from response and download
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `attendance_export_${date_from}_to_${date_to}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
    
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
